import styled from "styled-components";

export const HeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  margin-top: 9px;
`;
export const ArrowBack = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
export const MoreVert = styled.img`
  width: 44px;
  height: 44px;
  margin-right: -10px;
  cursor: pointer;
`;

export const MoreContainer = styled.div`
  position: relative;
  width: 100%;

  & > div {
    position: absolute;
    right: 0;
    width: 67.77%;

    background-color: rgba(237, 237, 237, 0.8);
    border-radius: 12px;
    box-sizing: border-box;

    filter: drop-shadow(0px 8px 64px rgba(0, 0, 0, 0.08));
    backdrop-filter: blur(80px);

    & div {
      padding: 11px 16px;
      font-weight: 500;
      cursor: pointer;
      color: #000;

      border-bottom: 0.5px solid rgba(60, 60, 67, 0.36);

      & a {
        color: #000;
      }
    }

    & :last-child {
      border: none;
    }
  }
`;
